import { defineMessages } from 'react-intl';

export default defineMessages({
  add: {
    id: 'GiftCard.button.add',
    description: 'Message for the gift card add option',
    defaultMessage: 'Add Gift Card',
  },
  applyButton: {
    id: 'GiftCard.applyButton',
    description: 'Message for the gift card apply option',
    defaultMessage: 'Apply',
  },
  giftCardNumberLabel: {
    id: 'GiftCard.label',
    descrition: 'Message for the gift card number label',
    defaultMessage: 'Gift Card Number',
  },
  giftCardPinLabel: {
    id: 'GiftCard.PIN.label',
    description: 'Message for the gift card pin label',
    defaultMessage: 'PIN',
  },
  giftCardPlaceHolder: {
    id: 'GiftCard.placeholder',
    description: 'Message for the gift card place holder',
    defaultMessage: '0000-0000-0000-0000-000',
  },
  giftCardPinPlaceHolder: {
    id: 'GiftCard.PIN.placeholder',
    description: 'Message for the Gift Card PIN placeholder',
    defaultMessage: '0000',
  },
  giftCardTitle: {
    id: 'GiftCard.title',
    description: 'Message for the gift card title',
    defaultMessage: 'Have a Gift Card?',
  },
  giftCardSubTitle: {
    id: 'GiftCard.subtitle',
    description: 'Message for the gift card subtitle',
    defaultMessage: 'Gift Card',
  },
  hide: {
    id: 'GiftCard.button.hide',
    description: 'Message for the gift card hide option',
    defaultMessage: 'Hide',
  },
  giftCardAlreadyApplied: {
    id: 'GiftCard.error.giftCardHasAlreadyBeenApplied',
    description:
      'Message when the gift card has already been applied to a cart.',
    defaultMessage: 'This gift card has already been applied to your cart.',
  },
  giftCardDoesNotExist: {
    id: 'GiftCard.error.giftCardDoesNotExist',
    description: 'Message when the gift card does not exist.',
    defaultMessage:
      'This code doesn’t match any valid gift card',
  },
  giftCardZeroBalance: {
    id: 'GiftCard.error.giftCardZeroBalance',
    description: 'Message when the gift card has zero balance.',
    defaultMessage:
      'This gift card has no balance. Please try another gift card.',
  },
  invalidGiftCardNumber: {
    id: 'GiftCard.error.invalidGiftCardNumber',
    description: 'Message when the gift card number field is invalid',
    defaultMessage:
      'This code doesn’t match any valid gift card',
  },
  invalidGiftCardPin: {
    id: 'GiftCard.error.invalidGiftCardPin',
    description: 'Message when the gift card pin field is invalid',
    defaultMessage: 'Invalid PIN. Contact 1-888-848-0248 for support.',
  },
  required: {
    id: 'GiftCard.error.required',
    description: 'Required label',
    defaultMessage: 'Required',
  },
  giftCardBalanceSubTitle: {
    id: 'GiftCard.Balance.subtitle',
    description: 'Message for the Gift Card Balance subtitle',
    defaultMessage: 'Gift Card Balance:',
  },
  giftCardMaxApplied: {
    id: 'GiftCard.error.giftCardMaxApplied',
    description: 'Message when the maximum gift card quantity has been applied',
    defaultMessage:
      'You have applied the maximum number of gift cards. Please remove some to continue adding',
  },
  giftCardTooltip: {
    id: 'GiftCard.data.tooltip',
    defaultMessage:
      '<h5>Gift Cards</h5><ul><li>Gift Card Number: 16-digit number that<br/>can be found on the front of your card</li><li>PIN: 4-digit security code number that<br/>can be found on the back of your card</li><li>If you are having any issues please<br/>contact 1-888-848-0248 for support</li></ul>',
  },
});
